<template>
  <section
    class="component-a07213a1"
    resmed-component-name="50/50_icon-line_text_list"
    v-bind:style="{
      'background-image':
        acf.layout['background-gradient'] ||
        `url(${acf.layout['background-image']})`,
      'background-color': acf.layout['background-color'],
      'padding-top': acf.layout['padding-top'],
      'padding-bottom': acf.layout['padding-bottom'],
    }"
  >
    <div
      class="component"
      v-bind:class="[
        `text-color-${acf.layout['text-color']}`,
        `alignment-${acf.layout['alignment']}`,
      ]"
    >
      <div class="container px-xs-sm-2">
        <div
          class="row justify-content-center"
          v-bind:class="{ '-has-name': acf.name }"
        >
          <div class="col col-md-11 col-lg-10">
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
              v-bind:align="
                acf.layout['alignment'] === 'center' ? 'center' : ''
              "
            ></eyebrow-icon>

            <div class="mb-3">
              <h2 class="mb-3" v-if="acf.headline" v-html="acf.headline"></h2>
              <ul v-if="acf.labels" class="labels">
                <li v-for="item in acf.labels" v-html="item.label"></li>
              </ul>

              <div
                v-if="acf.description"
                v-html="acf.description"
                v-bind:class="{
                  'px-lg-4 text-center': acf.layout['alignment'] === 'center',
                }"
              ></div>
            </div>

            <!-- list items -->
            <template v-if="acf.layout['style'] === 'list'">
              <div class="items">
                <div class="column-count">
                  <list
                    v-if="acf.content"
                    v-bind:type="acf.layout['list-style']"
                    v-bind:items="acf.content"
                  ></list>
                </div>

                <div
                  class="column-flex"
                  v-if="acf['content-2cols']"
                  v-for="col in acf['content-2cols']"
                >
                  <div class="item" v-for="item in col">
                    <h5 v-if="item.headline">{{ item.headline }}</h5>
                    <list
                      v-bind:type="acf.layout['list-style']"
                      v-bind:items="item.items"
                    ></list>
                  </div>
                </div>
              </div>
            </template>

            <!-- paragraphs -->
            <template v-if="acf.layout['style'] === 'paragraphs'">
              <div class="items">
                <div class="column-count" v-if="acf.content">
                  <div class="paragraphs">
                    <p v-for="content in acf.content" v-html="content.item"></p>
                  </div>
                </div>

                <div
                  class="column-flex"
                  v-if="acf['content-2cols']"
                  v-for="col in acf['content-2cols']"
                >
                  <div class="item" v-for="item in col">
                    <h5 v-if="item.headline">{{ item.headline }}</h5>
                    <p v-for="content in item.items" v-html="content.item"></p>
                  </div>
                </div>
              </div>
            </template>

            <!-- footnote -->
            <div
              v-if="acf.footnote"
              v-html="acf.footnote"
              class="mt-4"
              v-bind:class="{
                'text-center': acf.layout['alignment'] === 'center',
              }"
            ></div>

            <div
              v-if="acf.cta.href"
              class="call-to-action mt-5"
              v-bind:class="{
                'text-center': acf.layout['alignment'] === 'center',
              }"
            >
              <a
                v-bind:href="acf.cta.href"
                v-bind:target="acf.cta.target"
                class="btn cta-pill filled-red icon right-arrow"
                >{{ acf.cta.text }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import list from "../shared-support/list-a07213a1";

export default {
  name: "component-a07213a1", // 50/50_icon-line_text_list
  props: ["acf"],
  components: {
    list,
  },
};
</script>

<style lang="scss">
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-a07213a1 {
  background-size: cover;
  background-repeat: no-repeat;
  padding: 6rem 0 5rem 0;
}

.component-a07213a1,
.component-list-a07213a1 {
  .component {
    &.text-color-black {
      h2,
      p,
      li {
        color: $cc-resmed-black;
      }

      h2 {
        &:before {
          background-color: $cc-resmed-black;
        }
      }

      ul,
      ol {
        li {
          > .numbers span {
            border: 1px solid rgba($cc-resmed-dark-grey, 0.325);
          }
        }
      }
    }

    &.alignment-left {
      text-align: left;

      h2 {
        &:before {
          left: 0;
          transform: none;
        }
      }
    }

    &.alignment-center {
      h2,
      h5,
      p {
        text-align: center;
      }

      h2 + div {
        text-align: center;
      }
    }

    h2 {
      position: relative;
      margin: 0;
      color: $cc-resmed-white;

      &:before {
        content: "";
        position: absolute;
        top: -1rem;
        left: 50%;
        transform: translateX(-50%);
        width: 1.25rem;
        height: 3px;
        background-color: $cc-resmed-white;
      }

      + .labels {
        font-family: "Plus Jakarta Sans", sans-serif;
        font-weight: 700;
        padding: 0.75rem 0 2.5rem 0;

        @media (min-width: 768px) {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
        }

        li {
          padding: 0 0 0 2.25rem;
          margin: 0 0 0.75rem 0;
          display: inline-block;

          background-size: 1.25rem;
          background-position: left 2px;
          background-repeat: no-repeat;

          @media (min-width: 768px) {
            padding: 0 2rem 0 2.25rem;
          }

          @media (min-width: 992px) {
            margin: 0;
          }

          &:after {
            display: none;
          }

          &:nth-child(1) {
            background-image: url(data:image/svg+xml;base64,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);
          }

          &:nth-child(2) {
            background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIyMHB4IiBoZWlnaHQ9IjIwcHgiIHZpZXdCb3g9IjAgMCAyMCAyMCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5Hcm91cCA2PC90aXRsZT4gICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+ICAgIDxnIGlkPSJIb3ctdG8tY2xlYW4teW91ci1DUEFQLWVxdWlwbWVudCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+ICAgICAgICA8ZyBpZD0iSG93LXRvLWNsZWFuLXlvdXItQ1BBUC1lcXVpcG1lbnQtLTE0NDAtRDQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03ODIuMDAwMDAwLCAtMTQwMy4wMDAwMDApIj4gICAgICAgICAgICA8ZyBpZD0iMDQvL0NsZWFuaW5nLXlvdXItQ1BBUC1tYXNrIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMTIzNi4wMDAwMDApIj4gICAgICAgICAgICAgICAgPGcgaWQ9ImNvbnRlbnQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI1NS4wMDAwMDAsIDE2MS4wMDAwMDApIj4gICAgICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTQuMDAwMDAwLCAwLjAwMDAwMCkiPiAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSJ4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0NzMuMDAwMDAwLCAwLjAwMDAwMCkiPiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXAtNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDYuMDAwMDAwKSI+ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTcuMDcwOTgxOCwxNy4wNjk4OTM5IEMxMy4xNjU2MjQyLDIwLjk3NTI1MTYgNi44MzQzNzU4NSwyMC45NzUyNTE2IDIuOTI5MDE4MjIsMTcuMDY5ODkzOSBDLTAuOTc2MzM5NDA3LDEzLjE2NDUzNjMgLTAuOTc2MzM5NDA3LDYuODM0Mzc1ODUgMi45MjkwMTgyMiwyLjkyOTAxODIyIEM2LjgzNDM3NTg1LC0wLjk3NjMzOTQwNyAxMy4xNjU2MjQyLC0wLjk3NjMzOTQwNyAxNy4wNzA5ODE4LDIuOTI5MDE4MjIgQzIwLjk3NjMzOTQsNi44MzQzNzU4NSAyMC45NzYzMzk0LDEzLjE2NDUzNjMgMTcuMDcwOTgxOCwxNy4wNjk4OTM5IiBpZD0iRmlsbC0xIiBmaWxsPSIjREQyNzI2Ij48L3BhdGg+ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTEuNjIxNDY2NywxMCBMMTQuNjYzNzIzNCw2Ljk1Nzc0MzI1IEMxNS4xMTIwOTIyLDYuNTA5Mzc0NDYgMTUuMTEyMDkyMiw1Ljc4MzQ5ODY1IDE0LjY2MzcyMzQsNS4zMzYyNzY1OSBDMTQuMjE2NTAxMyw0Ljg4NzkwNzggMTMuNDkwNjI1NSw0Ljg4NzkwNzggMTMuMDQyMjU2OCw1LjMzNjI3NjU5IEwxMCw4LjM3ODUzMzM0IEw2Ljk1Nzc0MzI1LDUuMzM2Mjc2NTkgQzYuNTA5Mzc0NDYsNC44ODc5MDc4IDUuNzgzNDk4NjUsNC44ODc5MDc4IDUuMzM2Mjc2NTksNS4zMzYyNzY1OSBDNC44ODc5MDc4LDUuNzgzNDk4NjUgNC44ODc5MDc4LDYuNTA5Mzc0NDYgNS4zMzYyNzY1OSw2Ljk1Nzc0MzI1IEw4LjM3ODUzMzM0LDEwIEw1LjMzNjI3NjU5LDEzLjA0MTExIEM0Ljg4NzkwNzgsMTMuNDg5NDc4OCA0Ljg4NzkwNzgsMTQuMjE1MzU0NiA1LjMzNjI3NjU5LDE0LjY2MjU3NjcgQzUuNTU5ODg3NjIsMTQuODg3MzM0NCA1Ljg1MzQ0ODc3LDE0Ljk5ODU2NjYgNi4xNDcwMDk5MiwxNC45OTg1NjY2IEM2LjQzOTQyNDM0LDE0Ljk5ODU2NjYgNi43MzI5ODU0OSwxNC44ODczMzQ0IDYuOTU3NzQzMjUsMTQuNjYyNTc2NyBMMTAsMTEuNjIwMzE5OSBMMTMuMDQyMjU2OCwxNC42NjI1NzY3IEMxMy4yNjcwMTQ1LDE0Ljg4NzMzNDQgMTMuNTU5NDI4OSwxNC45OTg1NjY2IDEzLjg1Mjk5MDEsMTQuOTk4NTY2NiBDMTQuMTQ2NTUxMiwxNC45OTg1NjY2IDE0LjQ0MDExMjQsMTQuODg3MzM0NCAxNC42NjM3MjM0LDE0LjY2MjU3NjcgQzE1LjExMjA5MjIsMTQuMjE1MzU0NiAxNS4xMTIwOTIyLDEzLjQ4OTQ3ODggMTQuNjYzNzIzNCwxMy4wNDExMSBMMTEuNjIxNDY2NywxMCBaIiBpZD0iRmlsbC00IiBmaWxsPSIjRkZGRkZGIj48L3BhdGg+ICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4gICAgICAgICAgICAgICAgICAgICAgICA8L2c+ICAgICAgICAgICAgICAgICAgICA8L2c+ICAgICAgICAgICAgICAgIDwvZz4gICAgICAgICAgICA8L2c+ICAgICAgICA8L2c+ICAgIDwvZz48L3N2Zz4=);
          }
        }
      }
    }

    .items {
      margin-top: 3rem;

      > div {
        margin-top: 3rem;

        &:first-child {
          margin-top: 0;
        }
      }

      .column-count {
        ul,
        ol,
        .paragraphs {
          @media (min-width: 768px) {
            column-count: 2;
            column-gap: 4rem;
          }

          > * {
            -webkit-column-break-inside: avoid;
            page-break-inside: avoid;
            break-inside: avoid-column;
            // display: inline-flex; --> IE 11
          }
        }
      }

      .column-flex {
        @media (min-width: 768px) {
          display: flex;
          justify-content: center;
        }

        h5 {
          text-align: left;
          margin-bottom: 2rem;

          @media (max-width: 767px) {
            margin-top: 3rem;
          }
        }

        .item {
          flex-grow: 1;

          @media (min-width: 768px) {
            width: 50%;

            &:nth-child(1) {
              padding: 0 2rem 0 0;
            }

            &:nth-child(2) {
              padding: 0 0 0 2rem;
            }
          }
        }
      }
    }

    p + h5 {
      margin-top: 3rem;
    }

    ul,
    ol {
      padding: 0;
      margin: 0 auto;
      list-style: none;

      li {
        text-align: left;
        position: relative;
        color: $cc-resmed-white;
        // margin-bottom: 1.25rem;
        padding-bottom: 2.25rem;

        * {
          text-align: left !important;
        }

        &:after {
          content: "";
          position: absolute;
          bottom: 1.25rem;
          left: 0;
          width: 100%;
          height: 1px;
          background-color: rgba($cc-resmed-grey-30, 0.325);
        }

        > .content {
          display: block;
          padding-left: 2.5rem;
        }

        .bullets {
          span {
            transform: scale(1.75) translateY(-2px);
          }

          ~ .content {
            padding-left: 2.125rem;
          }
        }

        .bullets,
        .numbers {
          overflow: hidden;
          float: left;
          transform: translate3d(0, 0, 0);

          span {
            display: flex;
            align-items: center;
            justify-content: center;

            border-radius: 50%;
            width: 1.5rem;
            height: 1.5rem;
            text-align: center;

            @extend %body-small;
          }
        }

        .numbers span {
          border: 1px solid rgba($cc-resmed-white, 0.75);
        }
      }
    }

    ol {
      li {
        &:last-child {
          padding-bottom: 0;

          &:after {
            display: none;
          }
        }
      }
    }

    .cta {
      > a {
        margin: 0 0.5rem;
      }
    }
  }
}
</style>